/**
 * One colour per box, so several drawn at once stay tellable apart.
 *
 * Hex in a table rather than Tailwind classes, because the colour is chosen by index at runtime and
 * Tailwind only emits classes it can read in the source: `border-${name}-500` is generated by
 * nothing and arrives as no style at all. These are the 500 steps of the same scale the app already
 * uses for its green and destructive accents.
 *
 * Green leads, so the common case -- one object, or the one the pointer is on -- is the green the
 * boxes were asked to be. The rest only come into play once several are shown together.
 *
 * Six entries because `MAX_DETECTED_OBJECTS` is six, so no picture can run off the end of the list
 * and put two neighbours in the same colour.
 */
const BOX_COLOURS = ['#22c55e', '#3b82f6', '#f97316', '#a855f7', '#ec4899', '#06b6d4'] as const;

/** Stable for a given position in the list, so a row's chip and its box always agree. */
export const boxColour = (index: number): string =>
  BOX_COLOURS[((index % BOX_COLOURS.length) + BOX_COLOURS.length) % BOX_COLOURS.length];
